<template>
  <section class="modal__footer">
    <section class="modal__container">
      <div class="modal__bottom-row">
        <button class="modal__button modal__button_cancel" @click.prevent="$emit('close')">Отменить</button>
        <el-form-item>
          <button type="submit"
            @click.prevent="submitForm('parentData')"
            class="modal__button modal__button_save">
              Сохранить
          </button>
        </el-form-item>
      </div>
    </section>
  </section>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    name: 'ModalFooter',
    props: ['parentData', 'refs', 'mode'],

    methods: {
      ...mapMutations(['createTask', 'updateTask']),
      async submitForm(formName) {
        this.refs[formName].validate(async (valid) => {
          if (valid && this.mode !== 'edit') {
            this.parentData.backgroundSrc = this.parentData.backgroundSrc.replace(`${process.env.VUE_APP_BACKEND_HOST}`, '');
            this.parentData.backgroundSrcMobile = this.parentData.backgroundSrcMobile.replace(`${process.env.VUE_APP_BACKEND_HOST}`, '');
            
            this.$store.dispatch("create_banner", this.parentData);
            this.$emit('close');
          } else if (valid && this.mode === 'edit') {
            await this.$store.dispatch("update_banner", this.parentData);
            this.$router.go();
          }
        });
      }
    }
}
</script>

<style lang="scss" scoped>
.modal {
  &__container { padding: 22px; }
  &__bottom-row {
    display: flex;
    justify-content: space-between;
  }

  &__button {
    padding: 12px 40px;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;

    border: 0;
    cursor: pointer;

    &:focus { outline: none; }

    &_cancel {
      color: #56565A;
      background-color: #DADADA;
    }
    &_save {
      color: #FFFFFF;
      background-color: #0A467E;
    }
  }
}
</style>